
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/astrology-community",
      function () {
        return require("private-next-pages/astrology-community/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/astrology-community"])
      });
    }
  